{
  "adjectives": [
    "AMBER",
    "ARCTIC",
    "ARID",
    "ASHEN",
    "BITTER",
    "BLACK",
    "BLAZING",
    "BLEAK",
    "BLIND",
    "BOLD",
    "BRAZEN",
    "BRIGHT",
    "BRISK",
    "BROKEN",
    "BURIED",
    "BURNING",
    "COBALT",
    "COLD",
    "COPPER",
    "CRIMSON",
    "CRYSTAL",
    "DARK",
    "DEEP",
    "DIRE",
    "DISTANT",
    "DRIFTING",
    "DUSTY",
    "EARLY",
    "EASTERN",
    "EMERALD",
    "ENDLESS",
    "FADING",
    "FALLEN",
    "FERAL",
    "FIERCE",
    "FINAL",
    "FIRST",
    "FLEET",
    "FROZEN",
    "GILDED",
    "GLACIAL",
    "GLASS",
    "GOLDEN",
    "GRANITE",
    "GRAVE",
    "GREEN",
    "GREY",
    "HARD",
    "HIDDEN",
    "HIGH",
    "HOLLOW",
    "HUNGRY",
    "HUSHED",
    "IRON",
    "IVORY",
    "JAGGED",
    "KEEN",
    "LAST",
    "LEADEN",
    "LONE",
    "LONG",
    "LOST",
    "LUCKY",
    "MARBLE",
    "MIDNIGHT",
    "MISTY",
    "MOLTEN",
    "MOSSY",
    "MUTED",
    "NIMBLE",
    "NOBLE",
    "NORTHERN",
    "OBSIDIAN",
    "PALE",
    "PARCHED",
    "PATIENT",
    "QUIET",
    "RAGGED",
    "RAPID",
    "RESTLESS",
    "RISING",
    "ROGUE",
    "ROYAL",
    "RUSTED",
    "SAVAGE",
    "SCARLET",
    "SCORCHED",
    "SECRET",
    "SEVERE",
    "SHATTERED",
    "SHINING",
    "SILENT",
    "SILVER",
    "SLEEPING",
    "SLOW",
    "SODDEN",
    "SOLEMN",
    "SOUTHERN",
    "STEADY",
    "STEEL",
    "STERN",
    "STILL",
    "STONE",
    "SUDDEN",
    "SULLEN",
    "SUNLIT",
    "SWIFT",
    "TWILIGHT",
    "URGENT",
    "VALIANT",
    "VERDANT",
    "VIGILANT",
    "VIOLET",
    "WAKING",
    "WANDERING",
    "WESTERN",
    "WHITE",
    "WILD",
    "WINTER"
  ],
  "nouns": [
    "ANVIL",
    "ARROW",
    "AVALANCHE",
    "AXE",
    "BADGER",
    "BANNER",
    "BASTION",
    "BEACON",
    "BLADE",
    "BLIZZARD",
    "BOLT",
    "BRAMBLE",
    "BRIDGE",
    "CANYON",
    "CASCADE",
    "CASTLE",
    "CHARIOT",
    "CINDER",
    "CITADEL",
    "CLAW",
    "COMET",
    "COMPASS",
    "CONDOR",
    "CROWN",
    "CURTAIN",
    "CYCLONE",
    "DAGGER",
    "DRUM",
    "DUNE",
    "EAGLE",
    "ECHO",
    "EMBER",
    "FALCON",
    "FANG",
    "FERRY",
    "FLINT",
    "FLOE",
    "FORGE",
    "FOX",
    "FROST",
    "FURNACE",
    "GAMBIT",
    "GARDEN",
    "GATE",
    "GAUNTLET",
    "GLACIER",
    "HAMMER",
    "HARBOR",
    "HARVEST",
    "HAWK",
    "HELM",
    "HORIZON",
    "HORN",
    "HOUND",
    "HUNTER",
    "ICEBERG",
    "JACKAL",
    "JAVELIN",
    "KEYSTONE",
    "KNIGHT",
    "LADDER",
    "LANCE",
    "LANTERN",
    "LEGACY",
    "LION",
    "MANTLE",
    "MARSH",
    "MERIDIAN",
    "MESA",
    "MIRAGE",
    "MONSOON",
    "MOUNTAIN",
    "NEEDLE",
    "OASIS",
    "ORCHARD",
    "OTTER",
    "OWL",
    "PASSAGE",
    "PAWN",
    "PENDULUM",
    "PIKE",
    "PILLAR",
    "QUARRY",
    "QUIVER",
    "RAMPART",
    "RAVEN",
    "REAPER",
    "RIVER",
    "ROOK",
    "SABER",
    "SANDSTORM",
    "SCEPTER",
    "SCORPION",
    "SCYTHE",
    "SENTINEL",
    "SERPENT",
    "SHIELD",
    "SICKLE",
    "SIROCCO",
    "SPARROW",
    "SPEAR",
    "SPIRE",
    "STAG",
    "SUMMIT",
    "SUNDIAL",
    "TALON",
    "TEMPEST",
    "THICKET",
    "THORN",
    "THRONE",
    "THUNDER",
    "TIDE",
    "TORCH",
    "TOWER",
    "TRIDENT",
    "TUNDRA",
    "VANGUARD",
    "VIGIL",
    "VIPER",
    "WADI",
    "WILLOW",
    "WOLF",
    "WOLVERINE",
    "ZEPHYR"
  ]
}
